import css from './MrSneeki.css';
import sounds from './sounds/*.mp3';
const soundPaths = Object.values(sounds);
import irritatedMeowSound from './MrSneekiIrritated.mp3';
import MrSneekiGif from './MrSneeki.gif';
import MrSneekiWebp from './MrSneeki.webp';
import {wait} from "../utils";

const DIRECTIONS = ['bottom', 'left', 'top', 'right'];
const getRandomDirectionPair = (floorDirectionIndex) => {
    return {
        floorDirection: DIRECTIONS[floorDirectionIndex],
        moveDirection: DIRECTIONS[(floorDirectionIndex + 1) % DIRECTIONS.length]
    }
};

const playSound = (url, volume = 1) => {
    const audio = new Audio(url);
    audio.volume = .2 + volume * .6;
    return audio.play().catch(() => Promise.resolve());
};

const playRandomCatSound = () => {
    const someSoundPath = soundPaths[Math.floor(Math.random() * soundPaths.length)];
    return playSound(someSoundPath, Math.random());
};

const playIrritatedCatSound = () => playSound(irritatedMeowSound);

/**
 * Creates webP and fallback jpg/gif/png image pair.
 * @param imgUrl
 * @param fallbackImgUrl
 */
const createImageEl = (imgUrl, fallbackImgUrl) => {
    const containerEl = document.createElement('picture');

    [imgUrl, fallbackImgUrl].filter(url => !!url).forEach(srcset => {
        const el = document.createElement('source');
        el.setAttribute('srcset', srcset);
        el.setAttribute('type', 'image/' + srcset.split('.').pop());
        containerEl.appendChild(el);
    });

    if (fallbackImgUrl) {
        const imgEl = document.createElement('img');
        imgEl.setAttribute('src', fallbackImgUrl);
        containerEl.appendChild(imgEl);
    }

    return containerEl;
};

export class MrSneeki {
    constructor(shouldDoPeekaboo = false, parentEl = document.body, customClassName) {
        this._customClassName = customClassName;
        this._peekabooTime = 2000;
        this._containerEl = createImageEl(MrSneekiWebp, MrSneekiGif);
        this._containerEl.addEventListener('click', playIrritatedCatSound);
        this._setActiveClass();
        // todo allow custom node
        requestAnimationFrame(() => parentEl.appendChild(this._containerEl)); 

        this._isLoopRunning = false;
        if (shouldDoPeekaboo) {
            this.startLoop();
        }
    }

    startLoop() {
        this._isLoopRunning = true;
        this._loop();
    }

    stopLoop() {
        this._isLoopRunning = false;
    }

    async _loop() {
        if (this._isLoopRunning) {
            await this.peekaboo();
            await wait(this._peekabooTime * (.5 + 2 * Math.random()));
            await this._loop();
        }
    }

    async peekaboo() {
        const floorDirectionIndex = Math.floor(DIRECTIONS.length * Math.random());
        const randomCoord = 10 + Math.round(Math.random() * 80);

        const {floorDirection, moveDirection} = getRandomDirectionPair(floorDirectionIndex);
        const angle = floorDirectionIndex * 90;
        const scale = Math.random() + .8;
        const transformRotateStr = `transform: scale(${scale}) rotate(${angle}deg)`;

        const rules = [
            `${floorDirection}: 0%`,
            `${moveDirection}: ${randomCoord}%`
        ];
        this._setStyle([transformRotateStr + ` translateY(100%)`].concat(rules));
        this._setActiveClass(true);

        await wait(20);

        // make transitions smooth
        rules.push(`transition-duration: ${this._peekabooTime / 2}ms`, 'transition-property: transform');

        // appearance animation!!
        this._setStyle([transformRotateStr + ` translateY(20%)`].concat(rules));

        await playRandomCatSound();

        await wait(this._peekabooTime / 2);


        // hide animation
        this._setStyle([transformRotateStr + ` translateY(100%)`].concat(rules));

        await wait(this._peekabooTime / 2);

        this._reset();
    }

    getContainerEl() {
        return this._containerEl;
    }

    vanish() {
        this.stopLoop();
        setTimeout(() => 
            this._containerEl.parentElement && 
            this._containerEl.parentElement.removeChild(this._containerEl)
        , this._peekabooTime);
    }

    _reset() {
        this._setActiveClass(false);
        this._containerEl.removeAttribute('style');
    }

    _setActiveClass(isActive) {
        requestAnimationFrame(() =>
            this._containerEl.className = css.container +
                (isActive ? (' ' + css['container--active']) : '') +
                (this._customClassName ? (' ' + this._customClassName) : '')
        );
    }

    _setStyle(rules) {
        requestAnimationFrame(() => this._containerEl.setAttribute('style', rules.join('; ')));
    }
}
